import { AccessToken_FieldsFragment } from 'queries';

import Modal from 'common/modal';

import UpdateAccessTokenForm from './update-access-token-form';

type Props = {
  accessToken: AccessToken_FieldsFragment;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

export default function UpdateAccessTokenModal({ accessToken, setShowModal, showModal }: Props) {
  const onExitClick = () => {
    setShowModal(false);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={<UpdateAccessTokenForm accessToken={accessToken} onExitClick={onExitClick} />}
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
}
